export default __webpack_public_path__ + "static/media/goods.slider-removebg-preview.fe8611c8.svg";